import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { AllowedAccess } from 'react-permission-role'
import { TableBanks } from './TableBanks/TableBanks'
import { FormBank } from './FormBank/FormBank'

import { Button, Card, CardContent, Grid } from '@mui/material'
import { useFetchInitBanks } from './hooks'


const BankConfiguration = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitBanks({ location, paramsURL })

    const {
        //------------- globalStates
        globalStates,
        //------------- Actions
        Actions
    } = useFetchInit

    const { showForm } = globalStates

    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['156_CATALOGO_DE_BANCOS']} renderAuthFailed={<p>Error</p>}>
            <div className='content'>
                {(!showForm) && (
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>

                            <Card style={{ zIndex: '1' }}>
                                <CardContent>
                                    <div className='h4 mt-1 mb-1'> Catálogo de Bancos</div>
                                    <div className="border-bottom border-dark"></div>

                                    <div className="d-flex justify-content-end pt-4">
                                        <Button
                                            style={{ background: "#4b4b4c" }}
                                            variant="contained"
                                            type="button"
                                            onClick={() => { handleClickShowForm(true) }}>
                                            <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                        </Button>
                                    </div>


                                    <div className="pt-4"></div>
                                    <TableBanks useFetchInit={useFetchInit} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}
                {(showForm) && (
                    <FormBank useFetchInit={useFetchInit} />
                )}
            </div>
        </AllowedAccess>
    )
}

export {
    BankConfiguration
}